import { render, staticRenderFns } from "./HelpAdmin.vue?vue&type=template&id=52e55423"
import script from "./HelpAdmin.vue?vue&type=script&lang=js"
export * from "./HelpAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports